export const getCustomerParty = (state) => {
  return (
    (state?.customerSlice?.customer?.partyInfo &&
      state.customerSlice.customer.partyInfo?.find(
        (customerParty) => customerParty?.partyTypeCd === 'CustomerParty',
      )) ||
    {}
  );
};
export const getMailingAddress = (state) => {
  const customerParty = getCustomerParty(state);
  return (
    customerParty?.addresses?.find(
      (mailingAddress) => mailingAddress?.addrTypeCd === 'CustomerMailingAddr',
    ) || {}
  );
};
export const getPrimaryPhoneInfo = (state) => {
  /* check if we've started editing phone yet which is profileSlice state piece,
   otherwise look for customer party stuff*/

  const customerParty = getCustomerParty(state);
  return (
    customerParty?.phoneInfo?.find(
      (phonePrimary) => phonePrimary?.phoneTypeCd === 'CustomerPhonePrimary',
    ) || {}
  );
};
export const getSecondaryPhoneInfo = (state) => {
  const customerParty = getCustomerParty(state);
  return (
    customerParty?.phoneInfo?.find(
      (phonePrimary) => phonePrimary?.phoneTypeCd === 'CustomerPhoneSecondary',
    ) || {}
  );
};
export const getPolicyEmail = (policy) => {
  return policy.insured.partyInfo.find((party) => party.partyTypeCd === 'InsuredParty').emailInfo
    .emailAddr;
};

export const getPolicyMailingAddress = (policy) => {
  const address = policy.insured.partyInfo
    .find((partyInfo) => partyInfo.partyTypeCd === 'InsuredParty')
    .addresses.find((address) => address.addrTypeCd === 'InsuredMailingAddr');
  return `${address.addr1}, ${address.city}, ${address.stateProvCd} ${address.postalCode}`;
};

export const getStatementAddress = (policy) => {
  let address = policy.fullAccount.partyInfo[0].addresses.find(
    (policy) => policy.addrTypeCd === 'StatementAccountMailingAddr',
  );
  if (address) {
    return `${address.addr1}, ${address.city}, ${address.stateProvCd} ${address.postalCode}`;
  } else {
    address = policy.fullAccount.partyInfo[0].addresses.find(
      (policy) => policy.addrTypeCd === 'StatementAccountBillingAddr',
    );
    return `${address.addr1}, ${address.city}, ${address.stateProvCd} ${address.postalCode}`;
  }
};
export const getStatementEmailAddress = (statementAccount) => {
  const insuredParty = statementAccount.fullAccount?.partyInfo?.find(
    (party) => party.partyTypeCd === 'StatementAccountParty',
  );
  return insuredParty?.emailInfo?.emailAddr;
};
